module.exports = __webpack_public_path__ + "static/NanumSquareL-fa92696350da81f5da13e4563d9326db.woff";